import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { TaskCreationFormWrapper } from 'src/Components/Forms/Task/TaskCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateTaskDrawer = () => {
  const { t } = useTranslation();

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('tasks.create.title', 'Nouvelle tâche')}
      to={`/asset/${assetId}/tasks`}
    >
      {({ onClose }) => <TaskCreationFormWrapper onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateTaskDrawer;
